(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-ms-installation-tabs]').forEach(section => {
      if (section.dataset.guideBound) return; section.dataset.guideBound = 'true';
      const tabs = [...section.querySelectorAll('[data-ms-guide-tab]')], panels = [...section.querySelectorAll('[data-ms-guide-panel]')];
      function activate(tab, focus = false) {
        tabs.forEach(item => { const current = item === tab; item.setAttribute('aria-selected', String(current)); item.tabIndex = current ? 0 : -1; });
        panels.forEach(panel => { panel.hidden = panel.dataset.msGuidePanel !== tab.dataset.msGuideTab; if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause()); });
        if (focus) tab.focus({preventScroll: true});
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          const direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          const destination = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : direction ? (index + direction + tabs.length) % tabs.length : null;
          if (destination === null) return; event.preventDefault(); activate(tabs[destination], true);
        });
      });
      if (tabs.length) activate(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
    });
    root.querySelectorAll('[data-ms-contact-result]').forEach(result => { if (result.dataset.guideBound) return; result.dataset.guideBound = 'true'; result.focus(); });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
